module.exports = __webpack_public_path__ + "static/media/elegant-empire.6704dca2.md";